import React, { useState } from 'react';
import {
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
    Button,
    Select,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Image,
    Flex,
    Text
} from '@chakra-ui/react';
import { FaRegEdit, FaCaretDown } from 'react-icons/fa';
import PetSizeDialog from "./PetSizeDialog";

const petTypes = [
    // { name: 'INDIE', logo: '/pet.png', otherName: "" },
    { name: 'LABRADOR', logo: '/labrador.png', otherName: "" },
    { name: 'GOLDEN RETRIEVER', logo: '/retriever.png', otherName: "" },
    { name: 'GERMAN SHEPHERD', logo: '/german.png', otherName: "" },
    { name: 'BEAGLE', logo: '/BEAGLE.png', otherName: "" },
    { name: 'PITBULL', logo: '/pitbull.png', otherName: "" },
    { name: 'SHIH TZU/LASA', logo: '/SHIH_TZU.png', otherName: "" },
    { name: 'PUG', logo: '/pug.png', otherName: "" },
    { name: 'ROTTWEILER', logo: '/ROTTWEILER.png', otherName: "" },
    { name: 'DOBERMAN', logo: '/DOBERMAN.png', otherName: "" },
    { name: 'COCKER SPANIEL', logo: '/cocker_spanie.png', otherName: "" },
    { name: 'HUSKY', logo: '/husky.png', otherName: "" },
    // { name: 'FRENCH BULLDOG', logo: '/pet.png', otherName: "" },
    { name: 'BULL DOG', logo: '/bulldog.png', otherName: "" },
    { name: 'GREAT DANE', logo: '/great_dane.png', otherName: "" },
    // { name: 'LASA', logo: '/lasa.png', otherName: "" },
    { name: 'POMERANIAN', logo: '/lasa.png', otherName: "" },
    { name: 'BOXER', logo: '/BOXER.png', otherName: "" },
    { name: 'DACHSHUND', logo: 'assets/breed/dachshund.png', otherName: "" },
    { name: 'CAT', logo: '/cat.png', otherName: "" },
    { name: 'OTHER', logo: '', otherName: "" },
];

const PetEngraving = ({
    index,
    product,
    selectedPetType,
    setSelectedPetType,
    frontPetText,
    handlePetFrontEngChange,
    backPetText,
    handlePetBackEngChange,
    breedAge,
    handleBreedAgeChange,
    breedSize,
    handleBreedSizeChange,
    isOpen
}) => {
    const [isAccordionOpen, setIsAccordionOpen] = useState(isOpen ?? false);

    const handleAccordionToggle = (isOpen) => {
        setIsAccordionOpen(isOpen);
    };

    const getTextSizeClass = (text) => {
        return text?.length > 5 ? 'text-4xl' : 'text-6xl';
    };

    const [isBreedSize, setIsBreedSize] = useState(false);

    return (
        <div>
            <h6 className='pb-2'>Select Your Breed #{index + 1} <span className='text-2xl text-red-500
'>*</span></h6>
            {/* Pet type selection */}
            <Menu>
                <MenuButton as={Button} rightIcon={<FaCaretDown />} width="100%" height={selectedPetType && selectedPetType.logo !== "" ? "10%" : null}>
                    {selectedPetType ? (
                        <Flex align="center" gap={2}>
                            {selectedPetType.logo !== "" && (<Image src={"/" + selectedPetType.logo.split('/').pop()} boxSize="80px" alt={selectedPetType.name} />)}
                            {selectedPetType.name}
                        </Flex>
                    ) : (
                        "Select Your Breed #" + (index + 1)
                    )}
                </MenuButton>
                {selectedPetType && selectedPetType.name === "OTHER" && (
                    <input
                        type="text"
                        // maxLength={10}
                        pattern="[A-Za-z]*"
                        // value={frontPetText}
                        className="border px-2 py-1 rounded w-full mt-3"
                        placeholder="Enter Breed Name"
                        onChange={(e) => {
                            selectedPetType.otherName = e.target.value;
                            setSelectedPetType(selectedPetType)
                        }}

                    />
                )}
                <MenuList maxHeight="460px" overflowY="auto">
                    {petTypes.map((pet, index) => {
                        // const colors = ['blue.100', 'green.100', 'red.100'];
                        // const bgColor = colors[index % colors.length];
                        return (
                            <MenuItem
                                key={pet.name}
                                onClick={() => setSelectedPetType(pet)}
                            // bg={bgColor}
                            // _hover={{ bg: bgColor }} // keeps background color on hover
                            >
                                <Flex align="center" gap={2}>
                                    {pet.logo !== "" && (<Image src={"/" + pet.logo.split('/').pop()} boxSize="120px" alt={pet.name} />)}
                                    <Text fontWeight="bold">{pet.name}</Text>
                                </Flex>
                            </MenuItem>
                        );
                    })}
                </MenuList>
            </Menu>
            <div className="flex w-full gap-6 mt-2">

                <div>
                    <div className="flex items-center gap-2">
                        <label htmlFor="breedSizeSelect">Select Size <span className='text-2xl text-red-500
'>*</span></label>
                        <div
                            className="underline cursor-pointer text-sm text-[#000080]"
                            onClick={() => setIsBreedSize(true)}
                        >
                            Size Chart
                        </div>
                    </div>
                    <Select
                        id="breedSizeSelect"
                        border="1px solid"
                        _hover="none"
                        className="px-4 pt-0 mt-2"
                        width="45"
                        borderColor="#000080"
                        value={breedSize}
                        onChange={(e) => handleBreedSizeChange(e.target.value)}
                        required
                    >
                        <option value="">Select Size</option>
                        {/* <option value="Small (S)">Small (S)</option> */}
                        <option value="Medium (M)">Medium (M)</option>
                        <option value="Large (L)">Large (L)</option>
                        {/* <option value="X-Large (XL)">X-Large (XL)</option> */}
                    </Select>
                </div>
                <div>
                    <label htmlFor="breedAge">Select Breed Age <span className='text-2xl text-red-500
'>*</span></label>
                    <Select
                        id="breedAge"
                        border="1px solid"
                        _hover="none"
                        className="px-4 pt-0 mt-2"
                        width="45"
                        borderColor="#000080"
                        value={breedAge}
                        onChange={(e) => handleBreedAgeChange(e.target.value)}
                        required
                    >
                        <option value="">Select Breed Age</option>
                        {Array.from({ length: 15 }, (_, i) => (
                            <option key={i + 1} value={i + 1}>
                                {i + 1}
                            </option>
                        ))}
                    </Select>
                </div>
            </div>
            <Accordion allowMultiple onChange={() => handleAccordionToggle(!isAccordionOpen)} my={6}>
                <AccordionItem>
                    <h2>
                        <AccordionButton>
                            <FaRegEdit className="w-5 h-5 mr-2" />
                            <Box as="span" flex="1" textAlign="left">
                                Add Engraving {index !== undefined ? `#${index + 1}` : ''}<span className='text-2xl text-red-500
'> *</span>
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                    </h2>
                    {/* FRONT ENGRAVING SECTION */}
                    <AccordionPanel pb={4}>
                        <Text fontWeight="bold">Front Engraving</Text>
                        {/* Front preview image with engraving */}
                        <div className="w-full relative mt-4">
                            <img
                                className="h-[200px] aspect-[3/2] object-cover object-center"
                                src={product.frontPreviewImg}
                                alt="Front preview"
                            />
                            <div
                                className={`w-[300px] flex font-ScriptMTBold absolute inset-0 items-center justify-start z-10 text-left px-6 pt-11`}
                            >
                                {selectedPetType && (
                                    <Flex align="center" gap={2}>
                                        {selectedPetType && selectedPetType.logo !== "" && (<Image src={"/" + selectedPetType.logo.split('/').pop()} alt={selectedPetType.name} />)}
                                    </Flex>
                                )}
                                <div
                                    className={`-mt-2 ${getTextSizeClass(frontPetText)} font-ScriptMTBold ${selectedPetType?.logo === "" ? "text-center" : "text-left"
                                        }`}
                                >
                                    {frontPetText}
                                </div>
                            </div>
                        </div>

                        <input
                            type="text"
                            maxLength={10}
                            pattern="[A-Za-z]*"
                            value={frontPetText}
                            className="border px-2 py-1 rounded w-full mt-3"
                            placeholder="Front Engraving Text"
                            onChange={(e) => handlePetFrontEngChange(e.target.value)}
                        />
                        <p className="text-sm text-gray-500 mt-1">Max 10 characters, letters only. (Your Pet's Name)</p>
                    </AccordionPanel>



                    {/* BACK ENGRAVING SECTION */}
                    {product?.canBackEng && (
                        <AccordionPanel pb={4}>
                            <Text fontWeight="bold">Back Engraving</Text>
                            <div className="w-full relative mt-4">
                                <img
                                    className="h-[200px] w-[300px] aspect-[3/2] object-cover object-center"
                                    src={product.backPreviewImg}
                                    alt="Back preview"
                                />
                                <div className="w-[300px] flex text-[12px] font-MvBoli absolute inset-0 items-center justify-center z-10 text-center px-8 pt-12">
                                    If I am lost, Please call my parents at<br />
                                    +91-{backPetText?.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')}
                                </div>
                            </div>

                            <input
                                type="text"
                                inputMode="numeric"
                                maxLength={10}
                                value={backPetText}
                                className="border px-2 py-1 rounded w-full mt-3"
                                placeholder="Back Engraving Text"
                                onChange={(e) => handlePetBackEngChange(e.target.value)}
                                onKeyPress={(e) => {
                                    if (!/[0-9]/.test(e.key)) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            <p className="text-sm text-gray-500 mt-1">Max 10 characters, numbers only. (Contact Number)</p>
                        </AccordionPanel>
                    )}
                </AccordionItem>
            </Accordion>
            <PetSizeDialog
                isOpen={isBreedSize}
                onClose={() => setIsBreedSize(false)}
            />
        </div>
    );
};

export default PetEngraving;
